import { IErrorResponseType } from "../../constants/commonTypes";
import * as SuccessActions from "../actionTypes/successActionTypes";
import { SuccessState } from "../reducers/successReducer";


export function submitARCApprove(): SuccessActions.SubmitARCApproveAction {
  return {
    type: SuccessActions.SUBMIT_ARC_APPROVE,
  };
}

export function submitARCApproveRequest(): SuccessActions.SubmitARCApproveRequestAction {
  return {
    type: SuccessActions.SUBMIT_ARC_APPROVE_REQUEST
  }
}

export function submitARCApproveSuccess(response: SuccessState): SuccessActions.SubmitARCApproveSuccessAction {
  return {
    type: SuccessActions.SUBMIT_ARC_APPROVE_SUCCESS,
    response
  }
}

export function submitARCApproveFailure(error: Error | string | IErrorResponseType): SuccessActions.SubmitARCApproveFailureAction {
  return {
    type: SuccessActions.SUBMIT_ARC_APPROVE_FAILURE,
    error
  }
}
